<template>
  <div class="flex items-center justify-between gap-4 rounded-lg border p-4">
    <div class="flex min-w-0 flex-col gap-2">
      <div class="flex items-center gap-2">
        <span class="truncate font-semibold text-gray-900">{{ field.name }}</span>
        <Lock v-if="field.sensitive" class="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      </div>

      <div class="flex flex-wrap items-center gap-1.5">
        <Badge
          v-for="scope in field.scopes"
          :key="`${field.id}.${scope}`"
          variant="secondary"
          :capitalize="false"
          class="rounded-full font-medium"
        >
          {{ scopes.find(scope).label }}
        </Badge>
        <Badge
          v-if="field.auto_collect_during_onboarding"
          variant="indigo"
          :capitalize="false"
          class="gap-1 rounded-full font-medium"
        >
          <Sparkles class="h-3 w-3" /> Auto-collect
        </Badge>
      </div>
    </div>

    <Button variant="outline" size="sm" class="shrink-0" @click="emit('select')">Edit</Button>
  </div>
</template>

<script setup lang="ts">
import { Lock, Sparkles } from 'lucide-vue-next';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import type { CustomFieldEntity } from '@/api/entity_types/CustomField';
import * as scopes from './scopes';

defineProps<{ field: CustomFieldEntity }>();

const emit = defineEmits<{ select: [] }>();
</script>
